import { Select2OptionData } from "ng-select2";

export function getPrefixesOptions(): Select2OptionData[]{
  return [
    { id: '', text: 'Not Selected' },
    { id: 'Mr.', text: 'Mr.' },
    { id: 'Mrs.', text: 'Mrs.' },
    { id: 'Dr.', text: 'Dr.' },
    { id: 'Ms.', text: 'Ms.' },
    { id: 'Miss.', text: 'Miss.' },
  ]

}
